import {
  type InventorizationRegisterReading,
  readInventorizationRegisters,
} from '@/features/inventorization/domain/inventorization-reading';
import {
  createInventorizationRegisterId,
  createInventorizationRegisterLabel,
  DEFAULT_INVENTORIZATION_REGISTER_ID,
} from '@/features/inventorization/domain/inventorization-registers';
import { type CaptureSession, PHOTO_CONTEXTS } from '@/shared/capture/capture-session';

export function createNextManualRegister(session: CaptureSession): InventorizationRegisterReading {
  const registers = readInventorizationRegisters(session);
  const usedIds = new Set(registers.map(register => register.id));

  for (let index = 0; ; index += 1) {
    const id = createInventorizationRegisterId(index);

    if (!usedIds.has(id)) {
      return {
        counter: '',
        id,
        label: createInventorizationRegisterLabel(index),
        obis: '',
        photoRef: id,
        tariff: '',
        unit: '',
      };
    }
  }
}

export function getRegisterPhotos(session: CaptureSession, registerId: string) {
  const register = readInventorizationRegisters(session).find(
    candidate => candidate.id === registerId || candidate.photoRef === registerId,
  );

  return session.photos.filter(
    photo =>
      photo.context === PHOTO_CONTEXTS.register &&
      (photo.registerId === registerId ||
        photo.registerId === register?.photoRef ||
        (!photo.registerId && registerId === DEFAULT_INVENTORIZATION_REGISTER_ID)),
  );
}
